import {
  BenefitQuantity,
  BenefitTitle,
  BenefitWrapper,
} from "./coopBenefitsStyled";

import React from "react";

interface Props {
  readonly quantity: string;
  readonly title: string;
  readonly description: string;
}

export const CoopBenefit = ({
  quantity,
  title,
  description,
}: Props): React.ReactElement => {
  // TODO: Move texts to Ditto as soon as Ditto client trouble has been resolved.
  return (
    <BenefitWrapper>
      <BenefitQuantity>{quantity}</BenefitQuantity>
      <BenefitTitle>{title}</BenefitTitle>
      <p>{description}</p>
    </BenefitWrapper>
  );
};
